import React from 'react';
import {styled} from '@mui/material';

const TrayImage = styled('img')(({theme}) => ({
  display: 'block',
  maxWidth: '100%',
  height: 'auto',
  borderStyle: 'solid',
  borderWidth: 1,
  borderColor: theme.palette.borderColor,
  borderRadius: 4
}));

const TrayImageNoReferrer = (props: React.ComponentProps<typeof TrayImage>) => (
  <TrayImage {...props} referrerPolicy="no-referrer" />
);

export default TrayImageNoReferrer;
